import { useState } from "react";
import "./overlay.css";
import { toastify } from "../../helpers/toast/toastify";
import BubbleSvgButton from "../../pages/sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SettingDropdown from "../../pages/sharedPages/SettingDropdown/SettingDropdown";
import ProfileDropdown from "../../pages/sharedPages/ProfileDropdown/ProfileDropdown";

const Overlay = () => {
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const handleOnboarding = () => {
    if (user?.role === "leader") {
      navigate("/leader/onBoardingNotComplete");
    } else if (user?.role === "member") {
      if (!user?.onboarding?.payment) {
        navigate("/member/copyTrade");
        return;
      }

      if (!user?.onboarding?.connect) {
        navigate("onboarding/connection");
        return;
      }

      toastify("You onboarding steps are complete", "success");
      navigate("/member/dashboard");
    }
  };

  return (
    <div
      className="overlay"
      onClick={() => {
        if (user?.leaderCommunity) {
          toastify(
            "Click start to complete copy trade service onboarding",
            "error"
          );
          return;
        }
        toastify("Click START button to get started", "error");
      }}
    ></div>
  );
};

export default Overlay;
